import { render, staticRenderFns } from "./epg-filter.vue?vue&type=template&id=efdc4932"
import script from "./epg-filter.vue?vue&type=script&lang=js"
export * from "./epg-filter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports